import { createClient } from 'villus'
import { GetUserPermissionsDocument } from './rbac.global.generated'

const client = createClient({ url: '/graphql' })

export default defineNuxtRouteMiddleware(async () => {
  const { data: userPermissions, execute } = useQuery(
    { query: GetUserPermissionsDocument, fetchOnMount: false, client },
    ({ data }) => data?.user?.permissions,
  )

  await execute()

  if (!userPermissions.value) {
    return navigateTo({ name: 'sign-in' })
  }

  if (!userPermissions.value.canChangeOrg) {
    return navigateTo('/onboarding-wizard/user/method', { replace: true })
  }
})
